export default function sanitizePhone(phoneNumber: string): string {
  // Remove all non-digit characters
  let digits = phoneNumber.replace(/\D/g, '');

  // Prepend Czech country code (420) if not already present
  if (!digits.startsWith('420')) {
    digits = `420${digits}`;
  }

  return `+${digits}`;
}
